"use client";
import React, { useEffect, useState } from "react";
import WarningModal from "../WarningModal/WarningModal";
import { setCookie } from '../../lib/cookie';

function getCookie(key: string) {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}

const MessageBanner: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const COOKIE_NAME = "messageBannerAcknowledged";

  const messageType = process.env.NEXT_PUBLIC_MESSAGE_TYPE || "maintenance";
  const expiryDateRaw = new Date(process.env.NEXT_PUBLIC_MESSAGE_EXPIRY_DATE || "");
  expiryDateRaw.setDate(expiryDateRaw.getDate() - 1);

  const durationHours = process.env.NEXT_PUBLIC_MAINTENANCE_DURATION_HOURS || "4";
  const formattedDate = expiryDateRaw.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const rawTime = process.env.NEXT_PUBLIC_MAINTENANCE_START_TIME || "16.00";

  const [hoursStr, minutesStr = "00"] = rawTime.split(".");
  const dateObj = new Date();
  dateObj.setHours(Number(hoursStr), Number(minutesStr));

  const formattedTime = dateObj.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  useEffect(() => {
    if (messageType !== "maintenance") return; 

    const currentDate = new Date();
    const isAcknowledged = getCookie(COOKIE_NAME);
    const expiryDate = new Date(process.env.NEXT_PUBLIC_MESSAGE_EXPIRY_DATE || "");

    if (!isAcknowledged && currentDate < expiryDate) {
      setShowModal(true);
    }
  }, [messageType]);

  const handleClose = () => {
    setCookie(COOKIE_NAME, "true", 7);
    setShowModal(false);
  };

  if (messageType !== "maintenance") {
    return null;
  }

  const maintenanceMessage = (
    <>
      We would like to inform you that our system will undergo scheduled maintenance on <b>{formattedDate}</b>, starting from <b>{formattedTime} UK time (GMT+1)</b>. During this period, our services will be temporarily unavailable. This maintenance is part of our ongoing efforts to enhance system performance and security. We expect the downtime to last approximately <b>{durationHours} hours</b>, after which all services will be fully restored. We recommend planning any critical activities accordingly. We apologize for any inconvenience this may cause and appreciate your understanding and support. If you have any questions or need assistance, please don’t hesitate to contact us.
    </>
  );

  return (
    <WarningModal
      show={showModal}
      handleClose={handleClose}
      title="Warning"
      message={maintenanceMessage}
    />
  );
};

export default MessageBanner;
